module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-lateral-1-886702de87f71ccc78e6d296624e7110.jpg";